module.exports = __webpack_public_path__ + "static/media/img_2.3771ff4c.png";